import { render, staticRenderFns } from "./AbcTurnover.vue?vue&type=template&id=42cd2199&scoped=true"
import script from "./AbcTurnover.vue?vue&type=script&lang=js"
export * from "./AbcTurnover.vue?vue&type=script&lang=js"
import style0 from "./AbcTurnover.vue?vue&type=style&index=0&id=42cd2199&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cd2199",
  null
  
)

export default component.exports